export enum TasksTimeframe {
	Today = "today",
	ThisWeek = "this-week",
	ThisMonth = "this-month",
	AnyTime = "any-time",
}

export enum TasksStatus {
	AnyStatus = "any-status",
	Open = "open",
	Closed = "closed",
}

export enum RoleOptions {
	AssignedToMe = "assigned-to-me",
	OwnedByMe = "owned-by-me",
	AnyRole = "any-role",
}

export enum DomainLevel {
	GLOBAL = 0,
	PRODUCT = 1,
	SUBDOMAIN = 2,
}
